import { render, staticRenderFns } from "./his.vue?vue&type=template&id=305132e4&scoped=true"
import script from "./his.vue?vue&type=script&lang=js"
export * from "./his.vue?vue&type=script&lang=js"
import style0 from "./his.vue?vue&type=style&index=0&id=305132e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305132e4",
  null
  
)

export default component.exports